module.exports = __webpack_public_path__ + "img/5-2.1948a6d0.svg";